import React, { useEffect } from 'react';
import { setHeaderAction, setHeaderTitle } from 'features/ui/model/uiSlice';
import { useAppDispatch } from 'app/store';
import { DownloadsBonusesTable } from 'widgets/downloads';

export const DownloadsBonusesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Акции - Бонусы'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <DownloadsBonusesTable />;
};
